import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import { Button } from '@/shared/ui';
import { ROUTES } from '@/shared/config';

export const NotFoundPage: React.FC = () => {
  const location = useLocation();

  return (
    <div className="min-h-[600px] flex items-center justify-center p-4">
      <div className="text-center max-w-md">
        <div className="mb-6">
          <div className="mx-auto w-16 h-16 bg-warning/10 rounded-full flex items-center justify-center mb-4">
            <MapPin className="text-warning w-8 h-8" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            404
          </h1>
          <h2 className="text-xl font-semibold text-gray-700 mb-3">
            페이지를 찾을 수 없습니다
          </h2>
          <p className="text-gray-600 text-sm mb-4">
            요청하신 페이지가 존재하지 않거나 이동되었을 수 있습니다.
          </p>
          {location.pathname && (
            <p className="text-xs text-gray-500 bg-gray-100 p-2 rounded mb-4 font-mono">
              경로: {location.pathname}
            </p>
          )}
        </div>
        
        <div className="flex flex-col gap-2">
          <Link to={ROUTES.DASHBOARD}>
            <Button variant="primary" className="w-full">
              대시보드로 이동
            </Button>
          </Link>
          <Button 
            onClick={() => window.history.back()}
            variant="outline"
            className="w-full"
          >
            이전 페이지로
          </Button>
        </div>
      </div>
    </div>
  );
};